import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
// import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQrcode, faList, faListUl, faChartLine } from '@fortawesome/free-solid-svg-icons';
import './BigData.css';
import BaWChart from './BaWChart';

function BoxAndWhiskerChart() {
  const [selectedObservations, setSelectedObservations] = useState('');

  return (
    <div>
      <div className="main-content min-h-[500px] flex flex-col justify-center">
        <div className='flex justify-center text-2xl text-yellow-200 mb-16'>Sanjivani Hospital</div>
        
        <div className='flex justify-center text-lg text-yellow-200 mb-16'>
          <select
            value={selectedObservations}
            onChange={e => setSelectedObservations(e.target.value)}
            className="bg-gray-800 text-white p-2 rounded-md mr-8"
          >
            <option value="">Select Observations</option>
            <option value="bloodPressure">Blood Pressure (BP)</option>
            <option value="heartRate">Heart Rate (HR)</option>
            <option value="oxygenSaturation">Oxygen Saturation (SpO2)</option>
            <option value="respiratoryRate">Respiratory Rate (RR)</option>
            <option value="bodyTemperature">Body Temperature</option>
            <option value="bloodSugar">Blood Sugar Level</option>
            <option value="ecg">ECG</option>
            <option value="cholesterol">Cholesterol Level</option>
            <option value="hemoglobin">Hemoglobin (Hb)</option>
            <option value="plateletCount">Platelet Count</option>
            <option value="whiteBloodCells">White Blood Cell Count (WBC)</option>
            <option value="creatinine">Creatinine</option>
            <option value="urea">Blood Urea</option>
            <option value="liverFunction">Liver Function Test (LFT)</option>
            <option value="kidneyFunction">Kidney Function Test (KFT)</option>
            <option value="weight">Weight</option>
            <option value="height">Height</option>
            <option value="bmi">Body Mass Index (BMI)</option>
            <option value="painScale">Pain Scale (1-10)</option>
            <option value="urineOutput">Urine Output</option>
          </select>
        </div>

        <div className="min-h-[500px]">
          {BaWChart ()}
        </div>
      </div>
      <footer className="bg-black border-t border-blue-400 text-gray-400 py-4">
        <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-sm">© 2025 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" className="hover:text-teal-300">About</Link>
            <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
            <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
          </div>
        </div>
      </footer>            
    </div>
  );
};

export default BoxAndWhiskerChart;
